import React from "react";
import PropTypes from "prop-types";

import Icon from "../Icon";
import styles from "./KeepReading.css";

export default function KeepReading(props) {
  const { block, extras } = props;
  const { data } = block;
  const { wordCount } = (extras || {});
  return (
    <button id={`keep-reading-${block.key}`} className={styles.root} aria-expanded={false}>
      <Icon name="chevron/down" description="Read more toggle" className={styles.icon} />
      <div className={styles.showLess}>Show less</div>
      <div className={styles.keepReading}>
        {data.buttonText}
        {data.showWordCount && wordCount && <span className={styles.wordCount}>{wordCount} Words</span>}
      </div>
      <div className={styles.hide}>{props.children}</div>
    </button>
  );
}

KeepReading.propTypes = {
  block: PropTypes.object.isRequired,
  extras: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Library/KeepReading/KeepReading.js